const MoveLeftIcon = /*#__PURE__*/ [
  ["circle", { cx: "3", cy: "3", r: "3", transform: "matrix(-1 0 0 1 22 9)", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 11.9999H12M2 11.9999C2 12.5619 2.4381 12.9891 3.3143 13.8436L4.97057 15.5M2 11.9999C2 11.4378 2.4381 11.0106 3.3143 10.1561L4.97044 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { MoveLeftIcon as default };
//# sourceMappingURL=MoveLeftIcon.js.map
